import { datePattern } from '../components/shared/dateUtility';
import smartMap from '../components/smartMap';

const routes = {
  administration: {
    base: '/administration',
    pattern: `^/administration(.*)$`,
    vehicles: {
      base: '/administration/vehicles',
      pattern: `^/administration/vehicles(.*)$`,
    },
    vehicleSettings: {
      path: '/administration/vehicles/:vehicleId',
    },
  },
  dashboard: {
    base: '/dashboard',
    pattern: `^/dashboard(.*)$`,
    path: `/dashboard/:date(${datePattern})`,
  },
  orderOveriew: '/orderOverview',
  calendar: '/calendar',
  callordersPattern: `^/callorders(.*)$`,
  callordersPath: '/callorders',
  callorderDetailsPath: '/callorders/:orderId',
  serviceListsPattern: `^/servicelists(.*)$`,
  serviceListsPath: '/servicelists',
  serviceOrders: {
    path: '/servicelists/:listId',
    pattern: '^/servicelists(.*)$',
  },
  serviceOrderDetailsPath: '/servicelists/:listId/:listItemId',
  routeOptimalizationWizardPath: '/servicelists/add',
  orderDetails: {
    path: `/dashboard/:date(${datePattern})/:orderId`,
    pattern: `^/dashboard(.*)$`,
  },
  routeStopDetails: {
    base: 'routeStopDetails',
    path: `/dashboard/:date(${datePattern})/:orderId/routeStopDetails`,
  },
  reportsPath: '/reports',
  reportsPattern: '^/reports(.*)$',
  routeAdminPagePath: '/routesAdmin',
  routeAdminPagePattern: '^/routesAdmin(.*)$',
  impersonationManagerPath: '/impersonation',
  impersonationManagerPattern: '^/impersonation(.*)$',
  userAdminPath: '/userAdmin',
  userAdminPattern: '^/userAdmin(.*)$',
  customerSearch: '/customers',
  directMessages: '/directMessages',
  smartMap: '/smartMap',
  autoSequencRoute: '/autosequence',
  customerLogs: {
    base: '/customerLogs',
    customerLogDetail: '/customerLogs/customerLogDetails',
  },
  importRoutesWizard: '/import-routes',
  drivers: '/contractor-drivers',
  dataButtons: '/data-buttons',
};

export default routes;
